enum ProjectTypes {
  SET_PROJECTS = '[PROJECT] SET_ALL',
  SET_PROJECT = '[PROJECT] SET',
  SELECT_PROJECT = '[PROJECT] SELECT',
  REFETCH = '[PROJECT] REFETCH',
  SET_WORKSTATION_ENTITLEMENTS = '[PROJECT] SET_WORKSTATION_ENTITLEMENTS',
}

export default ProjectTypes;
